import { apiClient } from '@/http/apiClient';
import { buildQuery, joinUrl } from '@/http/url';
import { AxiosPromise } from 'axios';
const rootPath = 'Sites';


class SitesServices {
    public getTableUrl(lang:string): string {
        return joinUrl(apiClient.defaults.baseURL || '', rootPath) + buildQuery({lang});
    }

    public getTableUrlByAdministrator(lang:string): string {
        return joinUrl(apiClient.defaults.baseURL || '', rootPath, 'getByAdministrator') + buildQuery({lang});
    }

    public async getSites(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang})}`);
    }
    public async getSitesByAdministrator(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/getByAdministrator${buildQuery({lang})}`);
    }
    public async getEnabledSites(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/enabled${buildQuery({lang})}`);
    }
    public async getEntrepriseSites(entrepriseId:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/entreprise${buildQuery({lang,entrepriseId})}`);
    }

   

    public getTranslatedSite(id: any,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/${id}${buildQuery({lang})}`);
    }
    public addSite(data: any,lang:string): AxiosPromise {
        return apiClient.put(`${rootPath}/${data.site.id}${buildQuery({lang})}`, data);
    }
    public saveSites(data: Array<any>,lang:string): AxiosPromise {
        return apiClient.post(`${rootPath}${buildQuery({lang})}`, data);
    }
    public DeployBopModels(siteId:string,bopModelGuids: Array<string>){
        return apiClient.post(`${rootPath}/${siteId}/deploybopmodels`, bopModelGuids);
    }
    public getTranslationsUrl(): string {
        return joinUrl(apiClient.defaults.baseURL || '', rootPath, 'GetAllTranslations');
    }
    public saveTranslations(data: any): AxiosPromise {
        return apiClient.post(`${rootPath}/translations`, data);
    }

}

export default new SitesServices();